import {
  Container,
  Grid,
  Link,
  List,
  ListItem,
  ListItemButton,
  Typography
} from '@mui/material'
import { useTranslate } from 'react-admin'
import { useParams } from 'react-router-dom'

import { useEffect, useState } from 'react'
import { isNil, map } from 'lodash/fp'
import { getCategories, getContents } from 'components/Util/functions'
import { ContentItem } from 'components/Util/types'

type PathParams = {
  category: string
}

const Contents: React.FC = (): JSX.Element => {
  const translation = useTranslate()
  const { category } = useParams<PathParams>()
  const [categories, setCategories] = useState<string[] | undefined>(undefined)
  const [contents, setContents] = useState<ContentItem[] | undefined>(undefined)
  useEffect(() => {
    getCategories().then((result: string[] | undefined) => {
      setCategories(result)
    })
    getContents(category).then((result: ContentItem[] | undefined) => {
      setContents(result)
    })
  }, [])
  return isNil(category) ? (
    <></>
  ) : (
    <Container>
      <Grid container>
        <Grid item xs={12} sx={{ marginTop: 3, marginBottom: 3, fontSize: 15 }}>
          <Link
            href={`/`}
            sx={{
              textDecoration: 'none'
            }}>
            {translation('resources.category.title')}
          </Link>
          <Typography
            sx={{
              display: 'inline',
              margin: 2
            }}>
            &gt;
          </Typography>
          <Link
            href={`/${category}`}
            sx={{
              textDecoration: 'none'
            }}>
            {category}
          </Link>
        </Grid>
        <Grid item xs={3}>
          <Typography
            variant="h6"
            component="h2"
            fontWeight="bold"
            sx={{ maxWidth: '100%', fontSize: 20 }}>
            {translation('resources.category.title')}
          </Typography>
          <List
            sx={{
              marginLeft: 0,
              paddingLeft: 0
            }}>
            {map((category: string) => {
              return (
                <ListItem
                  sx={{
                    marginLeft: 0,
                    padding: 0
                  }}>
                  <ListItemButton
                    href={`/${encodeURIComponent(category)}`}
                    sx={{
                      marginLeft: 0,
                      paddingLeft: 0,
                      maxWidth: '100%',
                      fontSize: 15
                    }}>
                    {category}
                  </ListItemButton>
                </ListItem>
              )
            })(categories)}
          </List>
        </Grid>
        <Grid item xs={9}>
          <Typography variant="h4" component="h2" fontWeight="bold">
            {category}
          </Typography>
          <List>
            {map((content: ContentItem) => {
              const { id, title } = content
              return (
                <ListItem>
                  <ListItemButton
                    href={`/${encodeURIComponent(category)}/${id}`}>
                    {title}
                  </ListItemButton>
                </ListItem>
              )
            })(contents)}
          </List>
        </Grid>
      </Grid>
    </Container>
  )
}

export default Contents
